import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {userSearchResultStateSelector} from './user-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';
import type {UserSearchFiltering} from 'src/openapi/admin/models/UserSearchFiltering';
import type {UserSearchLimit} from 'src/openapi/admin/models/UserSearchLimit';
import type {UserSortField} from 'src/openapi/admin/models/UserSortField';

export const userSearchResultLimitsSlice = getCachedTableDataSlice<
    Record<string, UserSearchLimit[]>,
    UserSearchCriteria,
    UserSortField,
    UserSearchFiltering
>('userSearchResultLimits');

export const userSearchResultLimitsActions = userSearchResultLimitsSlice.actions;

const userSearchResultLimitsCacheSelector: CachedTableCacheSelector<Record<string, UserSearchLimit[]>>
    = state => state.userSearchResult.limits.cache;
export const userSearchResultLimitsDataSelector: CachedTableDataSelector<Record<string, UserSearchLimit[]>>
    = state => state.userSearchResult.limits;
export const userSearchResultLimitsResultSelector = getCachedTableResultSelector(
    userSearchResultLimitsCacheSelector,
    userSearchResultStateSelector,
);
